import { action, observable, runInAction } from 'mobx';

import { ErrorInterface } from 'modules/core/api/globalApi';
import { insuranceDocsController } from './insuranceDocsController';
import {
  InsuranceDocItemInterface, CreateInsuranceDocRequestInterface,
  DeleteInsuranceDocRequestInterface, 
} from '../../api/insuranceDocs';
import cloneDeep from 'lodash/cloneDeep';
// import forEach from 'lodash/forEach';
import orderBy from 'lodash/orderBy';

export interface InsuranceDocStore {
  insuranceDocs: InsuranceDocItemInterface[],
  insuranceDocsByOrderId: string,
  error: ErrorInterface,
}

export const insuranceDocStore: InsuranceDocStore = observable({
  insuranceDocs: [],
  insuranceDocsByOrderId: null,
  error: null,
} as InsuranceDocStore);

export const insuranceDocStoreActions = {

  getInsuranceDocs: async (orderId:string): Promise<void> => {

    // Если уже загружали для этого orderId - не делаем запрос
    if (insuranceDocStore.insuranceDocsByOrderId === orderId ) {
      return;
    }

    runInAction(() => {
      insuranceDocStore.insuranceDocsByOrderId = orderId;
    });
    insuranceDocStore.error = null;
    const response = await insuranceDocsController.getInsuranceDocs(orderId);
    insuranceDocStoreActions.handleError(response);
    if (!response.errorData) {

      runInAction(() => {
        insuranceDocStore.insuranceDocs = orderBy(response.data.items,['docTypeRefValueName'], ['asc'] ) ?? [];
      });
    };
  },

  setInsuranceDoc: async (request: CreateInsuranceDocRequestInterface): Promise<void> => {
    if (insuranceDocStore.insuranceDocsByOrderId !== request.orderId) { return };
    const x = cloneDeep(insuranceDocStore.insuranceDocs);
    const y = x.findIndex((v) => v.docTypeRefValueId === request.docTypeRefValueId);
    x[y] = {
      ...x[y],
      docStatusRefValueId: request.docStatusRefValueId,
      updated: true,
    };
    if (x[y].id && !request.docStatusRefValueId) {
      insuranceDocStoreActions.deleteInsuranceDoc({ orderDocTypeStatusId: x[y].id });
      x[y].setByUserFio = undefined;
      x[y].updatedDate = undefined;
    }
    if (request.docStatusRefValueId) {
      const response = await insuranceDocStoreActions.updateInsuranceDoc(request);
      x[y].id = response?.id;
      x[y].setByUserFio = response?.setByUserFio;
      x[y].updatedDate = response?.updatedDate;
    }

    runInAction(() => {
      insuranceDocStore.insuranceDocs = x;
    });
  },

  updateInsuranceDoc: async (request: CreateInsuranceDocRequestInterface): Promise<InsuranceDocItemInterface> => {
    const response = await insuranceDocsController.createInsuranceDoc(request);
    insuranceDocStoreActions.handleError(response);
    return response?.data;
  },

  // ✅ Прямая мутация вместо map + spread:
  updateInsuranceDocCount: action((id: string, count: number): void => {
    const item = insuranceDocStore.insuranceDocs.find(v => v.id === id);
    if (!item) return;
  
    const newCount = (item.fileCount ?? 0) + count;
    item.fileCount = newCount;
    item.docStatusRefValueId = newCount > 0 ? 631 : 632;
  }),

  deleteInsuranceDoc: async (request: DeleteInsuranceDocRequestInterface): Promise<void> => {
    const response = await insuranceDocsController.deleteInsuranceDoc(request);
    insuranceDocStoreActions.handleError(response);
  },

  saveInsuranceDocs: async (orderId:string): Promise<void> => {
    if (insuranceDocStore.insuranceDocsByOrderId !== orderId) { return };

    const x = insuranceDocStore.insuranceDocs.filter((v) => v.updated);
    if (x && x.length > 0) {
      const promises = x.map(async (item) => {
        if (item.docStatusRefValueId) {
          await insuranceDocStoreActions.updateInsuranceDoc({
            orderId,
            docTypeRefValueId: item?.docTypeRefValueId,
            docStatusRefValueId: item?.docStatusRefValueId,
          });
        };
        if (!item.docStatusRefValueId && item?.id) {
          await insuranceDocStoreActions.deleteInsuranceDoc({
            orderDocTypeStatusId: item?.id,
          });
        };

      });
      await Promise.all(promises);
      // insuranceDocStoreActions.getInsuranceDocs(orderId);
    }
  },

  /* setAvailableExecutor: async (userId:string, value: boolean): Promise<void> => {
    insuranceDocStore.executors.find(v => v.userId === userId).available = value;
  },

  setAvailableExecutors: async (nevValues: any): Promise<void> => {
    const x = cloneDeep(insuranceDocStore.executors);
    forEach(x, v => { v.available = nevValues.map(k => k.value).includes(v.userId); });
    insuranceDocStore.executors=x;
  },

  addOrderExecutors: async (request: AddExecutorsRequest): Promise<void> => {
    const response = await executorsController.addOrderExecutors(request);
    insuranceDocStore.handleError(response);
  },

  deleteOrderExecutors: async (id: string): Promise<void> => {
    const response = await executorsController.deleteOrderExecutors(id);
    executorsActions.handleError(response);
  },

  saveExecutors: async (orderId:string): Promise<void> => {
    if (insuranceDocStore?.executorsRequest?.orderId && orderId === executorsStore?.executorsRequest?.orderId) {
      const x = insuranceDocStore.executors.filter(v => v.available !== v.availableOrigin);
      if (x && x.length > 0) {
        const promises = x.map(async (item) => {
          if (item.available) {
            await insuranceDocStore.addOrderExecutors({
              userId: item.userId,
              orderId: insuranceDocStore.executorsRequest.orderId,
            });
          } else if (item?.id) {
            await executorsActions.deleteOrderExecutors(item?.id);
          }
        });
        await Promise.all(promises);
        executorsActions.getOrderExecutors(executorsStore.executorsRequest);
      }
    }
  }, */

  clearInsuranceDoc: action(() => {
    insuranceDocStore.insuranceDocs = [];
    insuranceDocStore.insuranceDocsByOrderId = null;
    insuranceDocStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      insuranceDocStore.error = data;
      throw data;
    }
  }),

};
